import styled, { css } from "styled-components";
import { Image } from "@commonlibs";

export const ProgramImageRoot = styled(Image)(
    ({ theme }) => css`
        width: 6.625rem;
        height: 6.625rem;
        border-radius: ${theme.borderRadius};
        min-width: 6.625rem;
    `,
);
